export default __webpack_public_path__ + "static/media/arial.c54859dd.ttf";